import {epos2Axios} from "@/interceptors/axios";

class SessionService {
    getSessionDetails() {
        return epos2Axios.get('/api/session');
    }
}
export default new SessionService();